import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=62b71288&scoped=true"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"
import style0 from "./privacy.vue?vue&type=style&index=0&id=62b71288&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b71288",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62b71288')) {
      api.createRecord('62b71288', component.options)
    } else {
      api.reload('62b71288', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=62b71288&scoped=true", function () {
      api.rerender('62b71288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/privacy/zh_TW/privacy.vue"
export default component.exports